export default "__VITE_ASSET__B3QLibeQ__"